import { createReducer, on } from '@ngrx/store';
import { ConfigurationsActions } from './configurations.actions';
import { ConfigurationsState } from './configurations.state';

export const initialState: ConfigurationsState = {
  configurations: [],
  configurationsIsFetching: false,
  searchValue: '',
  createConfigurationIsPending: false,
};

export const configurationsReducer = createReducer(
  initialState,
  on(ConfigurationsActions.resetConfigurationsState, () => initialState),
  on(
    ConfigurationsActions.setAllConfigurations,
    (state, { configurations }) => {
      const newState: ConfigurationsState = {
        ...state,
        configurations,
      };
      return newState;
    },
  ),
  on(ConfigurationsActions.patchConfiguration, (state, { configuration }) => {
    const newState: ConfigurationsState = {
      ...state,
      configurations: state.configurations.map((c) =>
        c.id === configuration.id ? configuration : c,
      ),
    };

    return newState;
  }),
  on(
    ConfigurationsActions.setGetAllConfigurationsIsFetching,
    (state, { isFetching }) => {
      const newState: ConfigurationsState = {
        ...state,
        configurationsIsFetching: isFetching,
      };
      return newState;
    },
  ),
  on(
    ConfigurationsActions.setCreateConfigurationIsPending,
    (state, { isPending }) => {
      const newState: ConfigurationsState = {
        ...state,
        createConfigurationIsPending: isPending,
      };
      return newState;
    },
  ),
  on(ConfigurationsActions.setSearchValue, (state, { searchValue }) => {
    const newState: ConfigurationsState = {
      ...state,
      searchValue,
    };
    return newState;
  }),
  on(ConfigurationsActions.getAllConfigurations, (state) => state),
  on(ConfigurationsActions.getConfiguration, (state) => state),
  on(ConfigurationsActions.addConfiguration, (state, action) => {
    const newState: ConfigurationsState = {
      ...state,
      configurations: [...state.configurations, action.configuration],
    };
    return newState;
  }),
);
